import { createClient } from '@supabase/supabase-js';

let url = import.meta.env.VITE_SUPABASE_URL as string;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string;
// In development the API is configured as localhost:8000. When the app is opened from another machine (LAN, Tailscale),
// use the host the page was loaded from instead, so the gateway is reachable from that machine too.
try {
  const u = new URL(url); const h = window.location.hostname;
  if (['localhost', '127.0.0.1'].includes(u.hostname) && !['localhost', '127.0.0.1'].includes(h)) { u.hostname = h; url = u.origin; }
} catch { /* leave as configured */ }
if (!url || !key) console.error('VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY are required (see .env.example)');

export const supabaseUrl = url;
export const supabase = createClient(url, key, { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false } });

/** Short-lived signed URL for a private file. */
export async function fileUrl(bucket: string, path: string, download?: string): Promise<string> {
  const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, 600, download ? { download } : undefined);
  if (error || !data) throw error ?? new Error('no url');
  return data.signedUrl;
}

/** Upload a file to a path issued by upload_ticket() or vendor_upload_ticket(). */
export async function uploadToTicket(bucket: string, path: string, file: File | Blob, contentType?: string) {
  const { error } = await supabase.storage.from(bucket).upload(path, file, { contentType: contentType ?? (file as File).type, upsert: false });
  if (error) throw error;
  return path;
}

export async function sha256(file: Blob): Promise<string> {
  const buf = await crypto.subtle.digest('SHA-256', await file.arrayBuffer());
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, '0')).join('');
}
